import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CobbAngle"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 12.75V11.25C15 10.4215 14.3284 9.74996 13.5 9.74996H7.5C6.67157 9.74996 6 10.4215 6 11.25V12.75C6 13.5784 6.67157 14.25 7.5 14.25H13.5C14.3284 14.25 15 13.5784 15 12.75ZM7.5 11.25H13.5V12.75H7.5V11.25ZM17.565 18.3599C17.3523 17.5689 16.5443 17.0948 15.75 17.2949L9.95248 18.8474C9.15407 19.06 8.67789 19.8782 8.88748 20.6774L9.27748 22.1249C9.44584 22.7775 10.0287 23.2376 10.7025 23.2499C10.8338 23.2439 10.9643 23.2263 11.0925 23.1974L16.89 21.6449C17.6891 21.4291 18.1624 20.6068 17.9475 19.8074L17.565 18.3599ZM10.7026 21.75L10.3201 20.295L16.1101 18.75L16.5001 20.19L10.7026 21.75ZM9.93005 5.14496L15.75 6.69746C15.8751 6.7296 16.0035 6.74721 16.1325 6.74996C16.8132 6.75294 17.4106 6.29723 17.5875 5.63996L18 4.18496C18.2149 3.38559 17.7417 2.56326 16.9425 2.34746L11.0925 0.794955C10.2932 0.580086 9.47086 1.05334 9.25505 1.85246L8.86505 3.29996C8.65546 4.09916 9.13163 4.91737 9.93005 5.12996V5.14496ZM10.6801 2.24996L16.5001 3.80246L16.1101 5.24996L10.3201 3.69746L10.6801 2.24996ZM10.5 15.75H12V17.25H10.5V15.75ZM10.5 6.74996H12V8.24996H10.5V6.74996Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CobbAngle.vue"]]);
